/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useRef, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';

import {
    Dialog,
    DialogBody,
    DialogIcon,
    DialogText,
    ContentTextarea,
    DialogCancel,
    DialogConfirm,
    Message,
    ButtonContainer
} from './styles';


export default function ModalEditConfirmation({ idOperation, show, setDialog, history, messages, onConfirm, onCancel, title }) {
    const myRef = useRef();

    return (
        <Dialog canShow={show} >
            <DialogBody ref={myRef}>
                <DialogIcon pink={'exclamation'}>
                    {/* <FontAwesomeIcon icon={['fas', 'exclamation']}></FontAwesomeIcon> */}
                    <DialogText>{title}</DialogText>
                </DialogIcon>
                <ContentTextarea>
                    {messages.map(message => {
                        if(typeof(message) === 'function'){
                            return (
                                <Message>{message()}</Message>
                            )
                        } else {
                            return (
                                <Message>{message}</Message>
                            )
                        }
                    })}

                </ContentTextarea>
                <ButtonContainer>
                    {onCancel && <DialogCancel type='button' onClick={onCancel}>CANCELAR</DialogCancel>}
                    {onConfirm && <DialogConfirm type='button' onClick={onConfirm}>CONFIRMAR</DialogConfirm>}
                </ButtonContainer>
            </DialogBody>
        </Dialog>

    );
}